<template>
	<div class="ReRentChargeItem">
		<div class="leftPart">
			<p class="time mr-4 mb-0">{{ value.dt_ins.split(' ')[1] }}</p>
			<!-- <div class="type_icon mx-1"> 
				<i v-if="value.operation_type == 'pay'" class="tim-icons icon-credit-card text-primary"></i>
				<i v-if="value.operation_type == 'rent'" class="tim-icons icon-wallet-43 text-primary"></i>
			</div> -->
			<!--div class="px-3">{{ value.operation_type }}</div-->
			<div class="description ml-2">
				<p class="mb-0">{{ value.comment }}</p>
				<!--div>agrm_id = {{ value.agrm_id }}</!--div-->
			</div>
		</div>
		<div class="amount" :class="[{'text-danger':value.operation_type==='rent'},{'text-success':value.operation_type==='pay'}]">
			<span v-if="value.operation_type==='rent'">-</span>{{ $GVO.number_format(value.amount,0,'.',' ') }} ₽
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ReRentChargeItem',
		components: {

		},
		props: {
			counter: String,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			value: Object,
		},
		data () {
			return {
				ver: 1,
				bufferValue: '',
			}
		},
		watch:{
			/*
			value(val){
				this.bufferValue = this.$GVO.unlinkObject(val);
			},
			bufferValue(val){
				this.bufferValue = val;
				this.$emit("input", this.bufferValue);
			},
			*/
		},
		computed: {

		},
		methods: {

		},
	}
</script>
<style scoped>
	.ReRentChargeItem{display:flex; justify-content: space-between; padding: 10px; align-items: center;}
	.ReRentChargeItem:nth-child(even) {background: rgb(1, 176, 224, 0.33);}
	.ReRentChargeItem>*{display:inline-flex; align-items: center;}
	.ReRentChargeItem .type_icon{
		width: 40px; 
		height: 40px; 
		border-radius: 50%; 
		background-color: #1d253b;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.amount {min-width: 100px; justify-content: flex-end;}
</style>
